export default function TracteursConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('tracteurs');
}

TracteursConfiguration.$inject = ['$translatePartialLoaderProvider'];
